<template>
    <div>
         <commBanner :obj="obj"></commBanner>
         <titleHead :headTitle="headTitle"></titleHead>
         <div class="w80 mb-30">
             <el-container>
                <el-aside width="330px">
                    <sidebar></sidebar>
                </el-aside>
                <el-main>
                    <headSide @release="onRelease()"></headSide>
                    <div class="mt-30">
                        <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
                        <div class="seach_box mt-30">
                            <div class="seach" style="width:60%;">
                                <el-input v-model="input" placeholder="输入标题搜索问题"></el-input>
                                <button  class="seachBtn" @click.prevent="onSeach()">搜索</button>
                            </div>
                            <div class="seach_cox">
                                <p @click="noAnswer()">未回答</p>
                                <p @click="onAnswer()">已回答</p>
                            </div>
                        </div>
                        <!--列表-->
                        <div v-if="show" class="fdw mt-30">
                              <div class="content" v-for="(item,index) in list" :key="index"  @click="onView(item)">
                                <div class="content_middle">
                                    <p style="max-width: 10em;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" :title="item.questionTitle">{{item.questionTitle}}</p>
                                    <p v-if="0==item.ispay" class='fn_red'>未支付</p>
                                    <p v-if="1==item.ispay" class='cont' style="color:green">已支付</p>

                                    <p :class="[item.status ==1?'fn_red':'cont']">{{item.status ==1?'未回答':'已回答'}}</p>
                                </div>
                                <div class="content_right">
                                    <p class="time">
                                    <span>提问人 :</span>
                                    <span>{{item.userName}}</span>
                                    </p>
                                    <p class="cont">
                                        <span>提问时间 :</span>
                                        <span>{{item.createDate.substring(0,10)}}</span>
                                    </p>
                                </div>
                              </div>
                        </div>
                         <!--分页-->
                         <div class="fcc">
                              <Pagination
                                v-show="total > 0"
                                :total="total"
                                :page.sync="listQuery.curPage"
                                :limit.sync="listQuery.limit"
                                @pageChange="pageChange"
                              ></Pagination>
                         </div>
                        <!--提问详情-->
                         <div id='answerquestion' v-if="hide ==true">
                            <div class="fsc mt-30">
                                <span class="line"></span>
                                <span class="cont_text" >提问详情</span>
                            </div>
                            <div class="question_details">
                                <div class="question_top">
                                    <p>{{problemObj.questionTitle}}</p>
                                    <div class="fdc">
                                        <p class="text">
                                            <span>提问人:</span>
                                            <span>{{problemObj.name}}</span>
                                        </p>
                                        <p class="text">
                                            <span>联系电话:</span>
                                            <span>{{problemObj.mobile}}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="question_fuar" style="color:red" v-html="problemObj.questionContent">
                                </div>
                                <!-- <div class="question_middle">
                                    <img src="../../assets/images/course.jpg">
                                    <img class="ml-15"  src="../../assets/images/course.jpg">
                                </div> -->
                                <div class="question_bottom">
                                    <p>
                                        <!-- <span>提问专家：</span><span>{{problemObj.expertname}}</span> -->
                                    </p>
                                    <p class="" v-if="problemObj.createdate">
                                        <span>提问时间：</span><span>{{problemObj.createdate.substring(0,10)}}</span>
                                    </p>
                                    <p class="ml-30">
                                    <span>回答情况：</span><span>{{problemObj.status ==1?'未答复':'已答复'}}</span>
                                    </p>

                                </div>
                                 <div class="question_bottom">
                                    <p>
                                      <span>回答内容：</span><span>{{problemObj.answer_content}}</span>
                                    </p>
                                 </div>
                                <div class="mt-20" v-for="(info,index) in problem" :key="index">
                                   <div v-if="info.type ==2" class="question_baser">
                                    <p>专家回答 :</p>
                                    <p>{{info.content}}</p>
                                   </div>
                                   <div v-if="info.type == 1"  class="question_baser">
                                        <p>用户追问 :</p>
                                        <p style="color:red">{{info.content}}</p>
                                   </div>
                                </div>

                            </div>


                            <!--回答提问-->
                            <div  class="fsc mt-30">
                                <span class="line"></span>
                                <span class="cont_text">回答提问</span>
                            </div>
                            <div class="question_anwer">
                                <div class="question_anwer_box">
                                    <el-input type="textarea" v-model="answer"></el-input>
                                </div>
                                <button @click.prevent="goAnswer()">立即回答</button>
                            </div>
                         </div>
                    </div>
                </el-main>
            </el-container>
         </div>
    </div>
</template>
<script>
import {question,answer} from "@/api/expert";
import{viewProblem,answerQuestion} from "@/api/coment"
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
export default {
  components:{
      sidebar,headSide,commBanner,titleHead,contTitle,Pagination
  },
  data(){
      return{
        contTitle:'我的提问',
        headTitle:'我的问题',
        obj:{
            title:'我的问题',
            contCount:'',
            isShow:true,
            roleType:'',
            personalType:9,
            // content:'公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...',
            // bannerUrl:require('@/assets/images/banner.jpg')
        },
        show:true,
        hide:false,
        input:'',
        answer:"",//追答
        list:[],  //
		titleList:[], //搜索
		notList:[],
        answers:[], //已回答
        listQuery:{
		  curPage:1,
		  limit:6,
		  // key:'',
		  // status:''
        },
        total:0,//总条数
        problemObj:{},
        questionId:'', //问题id
        problem:[],

      }
  },
  created(){
     this.getList();
     this.noAnswer();
     if(this.$store.state.user.userInfo.type == 2){
        this.obj.roleType = 2;
     }
  },
  methods:{
      //查看详情
      onView(row){
        // location.href="#answerquestion";
        this.hide = true;
        this.questionId = row.id;
        viewProblem({id:row.id}).then((res)=>{
          if(res.code ==0){
           this.problemObj = res.data;
           this.problem = res.data.data;
          }
        }).catch((err)=>{})
      },
      //未回答
      noAnswer(){
        this.listQuery.status = 1;
        question(this.listQuery).then((res)=>{
          if(res.code ==0){
            this.notList = res.data.list;
            // this.$store.commit('industry/SET_Count',this.notList.length)
            this.list = this.notList;
            this.total = res.data.totalCount;
            this.obj.contCount = res.data.totalCount;
          }
        }).catch((err)=>{})
      },
      //已回答
      onAnswer(){
        this.listQuery.status = 2;
        question(this.listQuery).then((res)=>{
          if(res.code ==0){
            this.answers = res.data.list;
            this.list = this.answers;
            this.total = res.data.totalCount;
          }
        }).catch((err)=>{})
      },
      //列表
      getList(){
        question(this.listQuery).then((res)=>{
          if(res.code ==0){
             this.list = res.data.list;
             this.total = res.data.totalCount;
          }
        }).catch((err)=>{})
      },
      //回答
      goAnswer(){
        this.problemObj.status=2;
        this.listQuery.status = 2;
        if( null!=this.problemObj.answer_content &&  this.problemObj.answer_content.length>0 && null!=this.problemObj.answer_date && this.problemObj.answer_date.length>0 ){
            this.getAnswer();
        }else{
            this.getAnswerQuestion();
        }
      },

     //回答问题
     getAnswerQuestion(){
        answerQuestion({
          answer:this.answer,
          questionId:this.questionId
        }).then((res)=>{
           if(res.code ==0){
               let ttime=new Date().toISOString().slice(0,10) +" "+new Date().toTimeString().slice(0,8);
               let newdata={content: this.answer,date: ttime,type: 2}  ;
               this.problem.push(newdata);
               this.answer ="";
               this.$message({
                message:'回答成功！',
                type: 'success',
                duration:1000,
               });
               this.noAnswer();
           }
        }).catch((err)=>{});
     },
     //追答问题
     getAnswer(){
         answer({
          answer:this.answer,
          questionId:this.questionId
         }).then((res)=>{
           if(res.code ==0){
               let ttime=new Date().toISOString().slice(0,10) +" "+new Date().toTimeString().slice(0,8);
               let newdata={content: this.answer,date: ttime,type: 2}  ;
               this.problem.push(newdata);
               this.answer ="";
               this.$message({
                message:'追答成功！',
                type: 'success',
                duration:1000,
               });
            }
         }).catch((err)=>{})
     },
      //分页
      pageChange(item){
         this.listQuery['curPage'] = item.page;
         this.listQuery['limit'] = item.limit;
		 this.getList()
      },
     //搜素
     onSeach(){
		 if(!this.input){
			delete this.listQuery.key
			delete this.listQuery.status
		    this.getList();
		 }else{
			this.listQuery.key = this.input;
			question(this.listQuery).then((res)=>{
				if(res.code == 0){
					this.titleList = res.data.list;
					this.list = this.titleList;
					this.total = res.data.totalCount;
				}
			}).catch((err)=>{})
		 }
     },
     //发布需求
     onRelease(){
        this.$router.push('/demand')
     }
  },
}
</script>
<style scoped>
/* .el-aside{
    height: 800px;
} */
.fdw{
 display: flex;
 justify-content: space-between;
 flex-wrap: wrap;
}
.ml-15{
    margin-left: 15px;
}
.mt-20{
    margin-top: 20px;
}
.ml-30{
    margin-left: 30px;
}
.mt-30{
    margin-top: 30px;
}
.mr-20{
    margin-right: 20px;
}

.cont_text{
  margin-left: 12px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.content{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 25px;
    height: 113px;
    width:47.8%;
    border: 1px solid #DEDEDE;
}
.content_middle{
   width: 100%;
   text-align: left;
   display: flex;
   padding:10px 15px;
   justify-content: space-between;
   /* align-items: center; */
}
.content_middle p:nth-child(1){
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp:2;
    height: 36px;
}
.content_middle p.cont{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
    width: 38px;
}
.fn_red{
   color: #FF7070;
   font-size: 12px;
   font-family: Microsoft YaHei;
   font-weight: 400;
   width: 38px;
}
.content_right{
   width: 100%;
   display: flex;
   padding: 0px 15px;
   flex-direction: column;
}
.content_right p.time{
  text-align: left;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
}
.content_right p.time span{
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.content_right p.time span:nth-child(2){
   display:inline-block;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
   width:60%;
}
.content_right p.cont{
    font-size: 12px;
    text-align:left;
}
.content_right p span{
    color: #343434;
}
.question_details{
    width: 100%;
    border: 1px solid #DEDEDE;
    margin-top: 20px;
    padding-bottom: 40px;
    text-align: left;
}
.question_top{
    margin-top: 15px;
    margin-left: 15px;
    display: flex;
    justify-content: space-between;
}
.question_top p{
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
}
.question_top p.text{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-right: 40px;
}
.question_fuar{
    margin-top: 20px;
    padding: 0px 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
}

.question_middle{
    margin-top:20px;
    margin-left: 15px;
}
.question_middle img{
    width: 206px;
    height: 143px;
}
.question_bottom{
    margin-top: 15px;
    margin-left: 15px;
    display: flex;
    justify-content: flex-start;
    align-content: center;
}
.question_bottom p span{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
}
.question_baser{
    /* margin-top: 20px; */
    display:flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 24px;
}
.question_baser p{
    width: 70px;
}
.question_baser p:last-child{
    flex: 1;
}
.question_anwer{
     border: 1px solid #DEDEDE;
     height: 300px;
     margin-top: 20px;
     text-align: left;
}
.question_anwer_box{
     /* border: 1px solid #DEDEDE; */
     /* height: 200px; */
     margin: 15px 20px;
}
.question_anwer_box>>>.el-textarea__inner{
    height: 200px;
}
.question_anwer button{
    width: 114px;
    height: 35px;
    background: #68BE32;
    border-radius: 3px;
    color: white;
    margin-left: 15px;
    margin-top: 20px;
}

.seach_box{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.seach{
    position: relative;
}
.seach>>>.el-input__inner{
    height: 40px;
    width: 100%;
    line-height: 40px;
}
.seachBtn{
    position: absolute;
    right: 0;
    top: 0;
    border: none;
    height: 40px;
    width: 80px;
    color: #ffffff;
    background: #3ba84d;
}
.seach_cox{
    width: 35%;
    display: flex;
    justify-content: flex-start;
}
.seach_box p{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-right: 20px;
}
.seach_box p:hover{
    cursor: pointer;
}
.el-pagination{
   margin-top: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/expert/expert_problem.vue